import { render, staticRenderFns } from "./recentShift.vue?vue&type=template&id=f5d74256&scoped=true"
import script from "./recentShift.vue?vue&type=script&lang=js"
export * from "./recentShift.vue?vue&type=script&lang=js"
import style0 from "./recentShift.vue?vue&type=style&index=0&id=f5d74256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d74256",
  null
  
)

export default component.exports